/* ARMA TU KIT - escalera de recompensas. 2026-09-07
 * Cuenta SOLO las piezas de la coleccion elegible (los regalos no cuentan).
 * El codigo se pone con /cart/update.js {discount} porque REEMPLAZA al anterior;
 * con /discount/CODIGO se apilaban y el carrito se quedaba atorado en el primero.
 * Los regalos se meten con /cart/add.js (change.js NO puede crear una linea nueva).
 * Los totales salen tal cual de Shopify: nunca se resta el descuento a mano.
 */
(function () {
  var CFG = window.ARMA;
  if (!CFG || !CFG.escalones || !CFG.escalones.length) return;

  var ESC = CFG.escalones.slice().sort(function (a, b) { return a.pzs - b.pzs; });
  var ELEG = {};
  (CFG.elegibles || []).forEach(function (id) { ELEG[String(id)] = true; });
  var REGALOS = {};
  ESC.forEach(function (e) { if (e.regalo) REGALOS[String(e.regalo)] = true; });

  var $ = function (id) { return document.getElementById(id); };
  var elResumen = $('armaResumen'), elFill = $('armaFill'), elNodes = $('armaNodes');
  var elWins = $('armaWins'), elMsg = $('armaMsg');
  var elSPzs = $('armaSPzs'), elSNext = $('armaSNext'), elSFill = $('armaSFill');
  var elTotal = $('armaTotal'), elAntes = $('armaAntes'), elAhorro = $('armaAhorro'), elCta = $('armaCta');
  if (!elNodes) return;

  var MAX = ESC[ESC.length - 1].pzs;
  var ocupado = false, COLA = [];

  function money(c) { return '$' + Math.round(c / 100).toLocaleString('es-MX'); }
  function get(u) { return fetch(u, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function post(u, b) { return fetch(u, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(b) }).then(function (r) { return r.json(); }); }

  function escalonDe(n) { var a = null; for (var i = 0; i < ESC.length; i++) if (n >= ESC[i].pzs) a = ESC[i]; return a; }
  function siguienteDe(n) { for (var i = 0; i < ESC.length; i++) if (n < ESC[i].pzs) return ESC[i]; return null; }
  function limpio(t) { return (t || '').replace(/gratis/ig, '').trim(); }

  function cuentaPiezas(cart) {
    var n = 0;
    cart.items.forEach(function (it) {
      var v = String(it.variant_id);
      if (REGALOS[v] || !ELEG[v]) return;
      n += it.quantity;
    });
    return n;
  }

  /* Deja en el carrito exactamente los regalos que toquen. true si movio algo. */
  function cuadrarRegalos(cart, piezas) {
    var pasos = [];
    ESC.forEach(function (e) {
      if (!e.regalo) return;
      var id = String(e.regalo), hay = 0;
      cart.items.forEach(function (it) { if (String(it.variant_id) === id) hay += it.quantity; });
      var toca = piezas >= e.pzs ? 1 : 0;
      if (hay === toca) return;
      if (toca > hay) pasos.push(function () { return post('/cart/add.js', { items: [{ id: Number(id), quantity: toca - hay }] }); });
      else pasos.push(function () { return post('/cart/change.js', { id: id, quantity: toca }); });
    });
    if (!pasos.length) return Promise.resolve(false);
    var cad = Promise.resolve();
    pasos.forEach(function (f) { cad = cad.then(f); });
    return cad.then(function () { return true; }).catch(function () { return false; });
  }

  function codigoActual(cart) {
    var c = null;
    (cart.discount_codes || []).forEach(function (d) { if (d.applicable) c = d.code; });
    return c;
  }

  function cuadrarCodigo(cart, code) {
    if ((code || null) === codigoActual(cart)) return Promise.resolve(false);
    return post('/cart/update.js', { discount: code || '' }).then(function () { return true; }).catch(function () { return false; });
  }

  function variantDe(card) {
    var sel = card.querySelector('.var');
    if (sel) return sel.value;
    var pr = card.querySelector('.pr');
    return pr ? pr.getAttribute('data-var') : null;
  }

  function pinta(cart) {
    var piezas = 0, subEleg = 0, porVariante = {};
    cart.items.forEach(function (it) {
      var v = String(it.variant_id);
      if (REGALOS[v] || !ELEG[v]) return;
      piezas += it.quantity;
      subEleg += it.original_line_price;
      porVariante[v] = (porVariante[v] || 0) + it.quantity;
    });

    var act = escalonDe(piezas), sig = siguienteDe(piezas);
    var pct = act ? act.pct : 0;
    var ahorro = cart.total_discount;
    var antes = cart.original_total_price;
    var total = cart.total_price;
    var avance = Math.min(100, Math.round(piezas / MAX * 100));

    elResumen.textContent = piezas + (piezas === 1 ? ' pieza' : ' piezas') + (pct ? ' · ' + pct + '%' : '');
    elFill.style.width = avance + '%';
    if (elSFill) elSFill.style.width = avance + '%';

    Array.prototype.forEach.call(elNodes.children, function (nd) {
      var p = parseInt(nd.getAttribute('data-pzs'), 10);
      nd.classList.toggle('on', piezas >= p);
      nd.classList.toggle('next', !!sig && sig.pzs === p);
      var dot = nd.querySelector('.dot');
      if (dot) dot.textContent = piezas >= p ? '✓' : p;
    });

    var ganados = ESC.filter(function (e) { return e.regalo && piezas >= e.pzs && e.regaloNom; });
    elWins.innerHTML = ganados.map(function (e) { return '<div class="win">✓ Ya tienes tu <b>' + limpio(e.regaloNom) + '</b> de regalo</div>'; }).join('');

    if (!sig) {
      elMsg.innerHTML = 'Llegaste al máximo. Estás pagando <b>' + pct + '% menos</b><s>Ahorras ' + money(ahorro) + ' en este pedido</s>';
      if (elSNext) elSNext.textContent = 'MÁXIMO DESBLOQUEADO';
    } else {
      var faltan = sig.pzs - piezas;
      var extra = sig.regaloNom ? ' y te llevas tu <b>' + limpio(sig.regaloNom) + '</b> de regalo' : '';
      var masAhorro = piezas > 0 ? '<s>Son ' + money(Math.round(subEleg * (sig.pct - pct) / 100)) + ' más de ahorro</s>' : '';
      elMsg.innerHTML = 'Agrega <b>' + faltan + (faltan === 1 ? ' pieza más' : ' piezas más') + '</b> y pagas ' + sig.pct + '% menos' + extra + masAhorro;
      if (elSNext) elSNext.textContent = faltan + ' más para ' + sig.pct + '%';
    }

    if (elSPzs) elSPzs.textContent = piezas + (piezas === 1 ? ' PIEZA' : ' PIEZAS') + (pct ? ' · ' + pct + '%' : '');
    if (elTotal) elTotal.textContent = money(total);
    if (ahorro > 0) {
      elAntes.hidden = false; elAntes.textContent = money(antes);
      elAhorro.hidden = false; elAhorro.textContent = 'Ahorras ' + money(ahorro);
    } else {
      elAntes.hidden = true; elAhorro.hidden = true;
    }
    if (elCta) {
      elCta.textContent = piezas > 0 ? CFG.ctaLleno : CFG.ctaVacio;
      elCta.classList.toggle('off', piezas === 0);
    }

    document.querySelectorAll('.arma .pcard').forEach(function (card) {
      var vid = variantDe(card);
      var q = porVariante[vid] || 0;
      card.classList.toggle('sel', q > 0);
      var badge = card.querySelector('.qty');
      if (badge) { badge.hidden = q === 0; badge.textContent = q; }
      var menos = card.querySelector('.menos');
      if (menos) menos.hidden = q === 0;
      var add = card.querySelector('.add');
      if (add) add.textContent = q > 0 ? 'AGREGAR OTRO' : 'AGREGAR';
    });
  }

  function refrescar() {
    return get('/cart.js').then(function (cart) {
      pinta(cart);
      return cuadrarRegalos(cart, cuentaPiezas(cart)).then(function (movio) {
        return (movio ? get('/cart.js') : Promise.resolve(cart)).then(function (c2) {
          var act = escalonDe(cuentaPiezas(c2));
          return cuadrarCodigo(c2, act ? act.code : null).then(function (cambio) {
            if (movio || cambio) return get('/cart.js').then(pinta);
          });
        });
      });
    }).catch(function () {});
  }

  /* Los clics se encolan: en datos lentos un tap nunca se pierde. */
  function accion(card, delta) { COLA.push({ card: card, delta: delta }); bombea(); }

  function bombea() {
    if (ocupado || !COLA.length) return;
    var job = COLA.shift();
    var vid = variantDe(job.card);
    if (!vid) return bombea();
    ocupado = true; job.card.classList.add('cargando');
    var p;
    if (job.delta > 0) {
      p = post('/cart/add.js', { items: [{ id: Number(vid), quantity: 1 }] });
    } else {
      p = get('/cart.js').then(function (cart) {
        var q = 0;
        cart.items.forEach(function (it) { if (String(it.variant_id) === String(vid)) q += it.quantity; });
        return post('/cart/change.js', { id: String(vid), quantity: Math.max(0, q - 1) });
      });
    }
    p.then(refrescar).catch(function () {}).then(function () {
      ocupado = false; job.card.classList.remove('cargando'); bombea();
    });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var add = e.target.closest('.arma .pcard .add');
    if (add) { e.preventDefault(); accion(add.closest('.pcard'), 1); return; }
    var menos = e.target.closest('.arma .pcard .menos');
    if (menos) { e.preventDefault(); accion(menos.closest('.pcard'), -1); }
  });

  document.addEventListener('change', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('var')) refrescar();
  });

  refrescar();
})();
